import React, { useRef } from 'react';
import history from '../../providers/history';
import { Container } from './styles';

const SubPagesContainer: React.FC = ({children}) => {
  const containerRef = useRef<HTMLDivElement|null>(null);

  return <Container ref={containerRef} onClick={(e) => {
    if(e.target === containerRef.current) {
      e.stopPropagation();

      history.back();
    }
  }}>
      {children}
  </Container>
}

export default SubPagesContainer;